import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PmContractState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PmContractState = {
  data: [],
  isLoading: false,
  error: null,
};

const PmContractSlice = createSlice({
  name: 'pmContract',
  initialState,
  reducers: {
    setPmContracts: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPmContractLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setPmContractError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setPmContracts, setPmContractLoading, setPmContractError } = PmContractSlice.actions;

export default PmContractSlice.reducer;
